module.exports = __webpack_public_path__ + "img/pago46.e8d34f8.png";